
import { Controller } from "@hotwired/stimulus";

/**
 * Stimulus controller to set the acupoll_passcode cookie if not already present.
 * Used for persistent passcode authentication across sessions.
 *
 * @class PasscodeCookieController
 * @extends Controller
 */
export default class extends Controller {
  /**
   * Passcode value passed from the DOM.
   * @type {String}
   */
  static values = { passcode: String };

  /**
   * Called when the controller is connected to the DOM.
   * Sets the acupoll_passcode cookie for 1 year if not already set.
   */
  connect() {
    // Only set the cookie if a passcode is provided and not already present
    if (this.passcodeValue && !document.cookie.match(/acupoll_passcode=/)) {
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      document.cookie = `acupoll_passcode=${encodeURIComponent(this.passcodeValue)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax;`;
    }
  }
}
